module.exports = __webpack_public_path__ + "static/media/Tanda_Baca.7c6e1456.png";